import TextInput from "components/inputs/text-input";
import ModalTemplate from "components/modal/modal-template";
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";

import Dropdown from "components/inputs/dropdown";
import { ISocialMediaIcon } from "constants/socialMediaIcons";
import { ISMBtn } from "../..";
import { isValidUrl } from "utils/isValidUrl";

interface IProps {
  addedButtons: string[];
  close: () => void;
  services: string[];
  save: (btn: ISMBtn) => void;
  editData?: ISMBtn;
  saveEdit?: (btn: ISMBtn) => void;
}
const AddSocialMediaModal = ({
  close,
  services,
  save,
  editData,
  saveEdit,
  addedButtons
}: IProps) => {
  const [dropdownValue, setDropdownValue] = useState<ISocialMediaIcon | "">("");
  const [url, setUrl] = useState("");

  const disableConfirm = useMemo(() => {
    if (dropdownValue.length === 0 || !isValidUrl(url)) {
      return true;
    }
    return false;
  }, [url, dropdownValue]);

  useEffect(() => {
    if (editData) {
      setDropdownValue(editData.button);
      setUrl(editData.url);
    }
  }, [editData]);
  return (
    <ModalTemplate
      close={close}
      header="Social Media Buttons"
      twoButtons
      confirmText="Save"
      cancelText="Cancel"
      disableConfirm={disableConfirm}
      confirm={() => {
        if (dropdownValue) {
          if (editData && saveEdit) {
            saveEdit({ button: dropdownValue, url });
          } else {
            save({ button: dropdownValue, url });
          }

          setDropdownValue("");
          setUrl("");
        }
      }}
    >
      <Dropdown
        placeholder="Choose Service..."
        label="Social Media Services"
        chosenItem={dropdownValue}
        items={services.filter((service) => !addedButtons.includes(service))}
        selectItem={(val) => setDropdownValue(val as ISocialMediaIcon)}
      />
      <Gap />
      <TextInput
        label="URL"
        placeholder="www.example.com"
        value={url}
        onChange={(e) => setUrl(e.target.value)}
      />
    </ModalTemplate>
  );
};

export default AddSocialMediaModal;

const Gap = styled.div`
  height: 1.6rem;
  width: 40rem;
`;
